import {ElMessage} from "element-plus";
const state = {
    selectPointGroup: {},  // 选中的点位信息  用于查询列表
    selectFromRelateTask: {},  //关联任务时的点位、表格信息
    selectedTableData: {},  // 选中的任务表格数据  用于添加/编辑采集
    selectedTaskProject: null, // 任务管理下选择的所在项目
    data_source_type:'1', //数据源  1：数据采集   2：实时视频流    3：图片文件    4：视频文件
    data_source_type_map:[
        {
          label: '采集数据接入',
          value: '1',
          isShow: true
        },
        {
          label: '实时视频流',
          value: '2',
          isShow: true
        },
        {
          label: '图片文件',
          value: '3',
          isShow: true
        },
        {
          label: '视频文件',
          value: '4',
          isShow: true
        }
      ],
      timeType:'1',//1实时任务  2轮巡任务
};

//操作管理
const mutations = {
    SET_SELECTED_POINT_GROUP(state, data = null) {
        state.selectPointGroup = data
    },
    SET_SELECTED_FROM_RELATE_TASK(state, data = null) {
        state.selectFromRelateTask = data
    },

    SET_SELECTED_TABLE_DATA(state, data = null) {
        state.selectedTableData = data
    },
    SET_SELECTED_TASK_PROJECT(state, data = null) {
        state.selectedTaskProject = data
    },
    // 移除缓存的界面
    REMOVE_CACHE(state, data = null) {
        state[data?.path] = null;
    },
    SET_DATA_SOURCE_TYPE(state,data=null){
        state.data_source_type=data
    },
    SET_TIME_TYPE(state,data=null){
        state.timeType=data
    }

}

// 异步操作
const actions = {
    // 设置选中的点位组信息
    setSelectedPointGroup({ commit }, data = null) {
        // 设置缓存
        commit("SET_SELECTED_POINT_GROUP", data);
    },
    // 设置新增和编辑时选中的点位信息
    setSelectFromRelateTask({ commit }, data = null) {
        // 设置缓存
        commit("SET_SELECTED_FROM_RELATE_TASK", data);
    },
    //选中的任务表格数据
    setSelectedTableData({ commit }, data = null){
        commit('SET_SELECTED_TABLE_DATA', data)
    },
    //任务管理下选择的所在项目
    setSelectedTaskProject({ commit }, data = null){
        commit('SET_SELECTED_TASK_PROJECT', data)
    },
    //移除窗口参数
    async removeQuery({ commit }, data = null) {
        commit("REMOVE_CACHE", data);
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
